/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultDetailViewModel } from "../types/CreditCardPaymentResultDetailViewModel.ts";

export const creditCardPaymentResultDetailViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  parcelId: z.optional(z.number().int()),
  studentName: z.string().nullish(),
  maskedCreditCard: z.string().nullish(),
  approved: z.optional(z.boolean()),
  requestStatus: z.string().nullish(),
  transactionCode: z.string().nullish(),
  authorizationCode: z.string().nullish(),
  creditCardRecurrenceId: z.string().nullish(),
  lastDataRequest: z.string().nullish(),
  creationDate: z.string().datetime().nullish(),
  creationDateText: z.string().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
  lastChangeDateText: z.string().nullish(),
  refunded: z.optional(z.boolean()),
  partiallyRefunded: z.optional(z.boolean()),
  refundDateText: z.string().nullish(),
  totalRefund: z.number().nullish(),
  chargedBack: z.optional(z.boolean()),
  chargebackDateText: z.string().nullish(),
  chargebackValue: z.number().nullish(),
}) as unknown as ToZod<CreditCardPaymentResultDetailViewModel>;
